import Accordion from '@/js/utils/accordion';
import { defineModule } from '@/js/utils/helpers';

const getElements = () => ({
  faqItems: document.querySelectorAll<HTMLDetailsElement>(
    '.content-block--faq details',
  ),
});

const accordions: Accordion[] = [];

export default defineModule(
  () => {
    const { faqItems } = getElements();

    accordions.push(...Array.from(faqItems).map((item) => new Accordion(item)));
  },
  () => {
    while (accordions.length) {
      accordions.pop()?.destroy();
    }
  },
);
